<template>
  <b-form class="sedna_form_vcenter" @submit.stop.prevent>
    <b-row align-h="center" style="width:100%">
      <b-col lg="5" md="10" sm="12">
        <slot />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>

export default {
  name: "centered-box",
};
</script>
